import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { FilterSection } from '../FilterSection'
import { defineMessages, useIntl } from 'react-intl'
import { selectFilter } from '../../../../store/selectors/filters'
import { FilterCheckBox } from '../FilterCheckBox'
import { useListingStatusDisplayObj } from '../../../../hooks/useListingStatusDisplayObj'
import { ListingStatusEnum } from '../../../../types/listingStatus'
import { FilterProperties } from '../../../../types/filtersTypes'
import { RootState } from '../../../../types/rootState'

// todo share these with HomeType.module.scss
import styles from './ListingStatus.module.scss'
import { useTheme } from '@homebotapp/hb-react-component-catalog'

export const MSG = defineMessages({
  heading: {
    id: 'HomeSearch.listings.filters.listingStatus.heading',
    defaultMessage: 'Listing status'
  }
})

export const ListingStatus = () => {
  const intl = useIntl()
  const filters = useSelector<RootState, FilterProperties>(selectFilter)
  const [selectedStatusActive, setSelectedStatusActive] = useState(true)
  const [selectedStatusPending, setSelectedStatusPending] = useState(false)
  const [selectedStatusComingSoon, setSelectedStatusComingSoon] = useState(true)
  const [selectedStatusActiveUnderContract, setSelectedStatusActiveUnderContract] = useState(false)
  const [selectedStatusClosed, setSelectedStatusClosed] = useState(false)
  const { theme } = useTheme()

  useEffect(() => {
    setSelectedStatusActive(filters.statuses.includes(ListingStatusEnum.ACTIVE))
    setSelectedStatusPending(filters.statuses.includes(ListingStatusEnum.PENDING))
    setSelectedStatusComingSoon(filters.statuses.includes(ListingStatusEnum.COMING_SOON))
    setSelectedStatusActiveUnderContract(filters.statuses.includes(ListingStatusEnum.ACTIVE_UNDER_CONTRACT))
    setSelectedStatusClosed(filters.statuses.includes(ListingStatusEnum.CLOSED))
  }, [filters])

  return (
    <FilterSection title={intl.formatMessage(MSG.heading)}>
      <fieldset className={styles.checkBoxFields}>
        <FilterCheckBox
          name={ListingStatusEnum.ACTIVE}
          iconName='circle'
          iconColor={theme.tokens[theme.isLightThemeType ? 'brand-secondary-300' : 'brand-secondary-600']}
          isChecked={selectedStatusActive}
          label={useListingStatusDisplayObj(ListingStatusEnum.ACTIVE).text}
          onChange={() => setSelectedStatusActive(s => !s)}
        />
        <FilterCheckBox
          name={ListingStatusEnum.COMING_SOON}
          iconName='circle'
          iconColor={theme.tokens[theme.isLightThemeType ? 'brand-secondary-300' : 'brand-secondary-600']}
          isChecked={selectedStatusComingSoon}
          label={useListingStatusDisplayObj(ListingStatusEnum.COMING_SOON).text}
          onChange={() => setSelectedStatusComingSoon(s => !s)}
        />
        <FilterCheckBox
          name={ListingStatusEnum.PENDING}
          iconName='circle'
          iconColor={theme.tokens[theme.isLightThemeType ? 'brand-secondary-accent-300' : 'brand-secondary-accent-600']}
          isChecked={selectedStatusPending}
          label={useListingStatusDisplayObj(ListingStatusEnum.PENDING).text}
          onChange={() => setSelectedStatusPending(s => !s)}
        />
        <FilterCheckBox
          name={ListingStatusEnum.ACTIVE_UNDER_CONTRACT}
          iconName='circle'
          iconColor={theme.tokens[theme.isLightThemeType ? 'brand-secondary-accent-300' : 'brand-secondary-accent-600']}
          isChecked={selectedStatusActiveUnderContract}
          label={useListingStatusDisplayObj(ListingStatusEnum.ACTIVE_UNDER_CONTRACT).text}
          onChange={() => setSelectedStatusActiveUnderContract(s => !s)}
        />
        <FilterCheckBox
          name={ListingStatusEnum.CLOSED}
          iconName='circle'
          iconColor={theme.tokens[theme.isLightThemeType ? 'brand-danger-600' : 'brand-danger-200']}
          isChecked={selectedStatusClosed}
          label={useListingStatusDisplayObj(ListingStatusEnum.CLOSED).text}
          onChange={() => setSelectedStatusClosed(s => !s)}
        />
      </fieldset>
    </FilterSection>
  )
}
